import React from "react";

export default function InvestSmartSection() {
  return (
    <div className="md:pl-44">
    <div className="max-w-3xl px-4 py-5 md:py-10">
      <h3 className="text-2xl md:text-3xl font-bold text-[#1B0727] mb-4">Let’s Help You Invest Smart</h3>
      <p className="text-gray-700 mb-6">Buying a plot doesn’t need to be complicated. Urban Nest simplifies your journey with:</p>
      <ul className="text-left space-y-3 max-w-md text-gray-800 list-disc list-inside">
        <li>Verified legal documents</li>
        <li>Site visit coordination</li>
        <li>End-to-end support from booking to registration</li>
        <li>Investment advice for long-term ROI</li>
      </ul>
    </div>
    </div>
  );
}
